module.exports = ol.source.TileWMS;